(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prugein-guest-access"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STATE = {
      CHECKING: 'checking',
      VALID: 'valid',
      PROCESSING: 'processing',
      SUCCESS: 'success',
      PENDING_REVIEW: 'pending_review',
      APP_REQUIRED: 'app_required',
      CLAIMED: 'claimed',
      EXPIRED: 'expired',
      CLOSED: 'closed',
      INVALID: 'invalid',
      RATE_LIMITED: 'rate_limited'
    };

    const COPY = {
      checking: { heading: 'Checking access.', body: 'Please wait.' },
      valid: { heading: 'Guest access has been issued.', body: 'Enter your phone number to continue.' },
      processing: { heading: 'Confirming access.', body: 'Do not close this page.' },
      success: { heading: 'Access confirmed.', body: 'Open PRUGEIN to continue.' },
      pending_review: { heading: 'Request received.', body: 'Access is pending review.' },
      app_required: { heading: 'PRUGEIN app required.', body: 'Open or install PRUGEIN to continue.' },
      claimed: { heading: 'This invite has already been claimed.', body: '' },
      expired: { heading: 'This access link is no longer active.', body: '' },
      closed: { heading: 'This guest access is no longer active.', body: '' },
      invalid: { heading: 'This access link is unavailable.', body: 'Check the link and try again.' },
      rate_limited: { heading: 'Too many attempts. Try again later.', body: '' }
    };

    const PLACEHOLDERS_BY_CODE = {
      '+1': '555 123 4567',
      '+44': '07123 456789',
      '+33': '06 12 34 56 78',
      '+49': '0151 23456789',
      '+39': '312 345 6789',
      '+34': '612 34 56 78',
      '+31': '06 12345678',
      '+41': '078 123 45 67',
      '+61': '0412 345 678',
      '+65': '8123 4567',
      '+81': '090 1234 5678',
      '+91': '098765 43210',
      '+971': '050 123 4567'
    };

    var INVITE_STORAGE_KEY = 'prugein_guest_access_invite';
    var TERMINAL_INVITE_STATES = {};
    TERMINAL_INVITE_STATES[STATE.INVALID] = true;
    TERMINAL_INVITE_STATES[STATE.CLAIMED] = true;
    TERMINAL_INVITE_STATES[STATE.EXPIRED] = true;
    TERMINAL_INVITE_STATES[STATE.CLOSED] = true;
    TERMINAL_INVITE_STATES[STATE.RATE_LIMITED] = true;

    function stripInviteQueryFromUrl() {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('invite')) return;
      url.searchParams.delete('invite');
      var qs = url.searchParams.toString();
      var next = url.pathname + (qs ? '?' + qs : '') + url.hash;
      history.replaceState(null, '', next);
    }

    function readStoredInvite() {
      try {
        return (sessionStorage.getItem(INVITE_STORAGE_KEY) || '').trim();
      } catch (e) {
        return '';
      }
    }

    function writeStoredInvite(token) {
      try {
        if (token) sessionStorage.setItem(INVITE_STORAGE_KEY, token);
        else sessionStorage.removeItem(INVITE_STORAGE_KEY);
      } catch (e) {}
    }

    function bootstrapInviteToken() {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = (params.get('invite') || '').trim();
      if (fromUrl) {
        writeStoredInvite(fromUrl);
        stripInviteQueryFromUrl();
        return fromUrl;
      }
      return readStoredInvite();
    }

    function initSection(root) {
      if (!root || root.dataset.prugeinGuestAccessInitialized === 'true') return;
      root.dataset.prugeinGuestAccessInitialized = 'true';

      const headingEl = root.querySelector('[data-status-heading]');
      const bodyEl = root.querySelector('[data-status-body]');
      const formEl = root.querySelector('[data-phone-form]');
      const countryCodeEl = root.querySelector('[data-country-code]');
      const phoneInputEl = root.querySelector('[data-phone-input]');
      const inlineErrorEl = root.querySelector('[data-inline-error]');
      const submitButtonEl = root.querySelector('[data-submit-button]');
      const actionsEl = root.querySelector('[data-actions]');
      const openAppButtonEl = root.querySelector('[data-open-app]');
      const fallbackCopyEl = root.querySelector('[data-fallback-copy]');
      const installAreaEl = root.querySelector('[data-install-area]');
      const installLinkEl = root.querySelector('[data-install-link]');

      const CONFIG = {
        resolveEndpoint: root.dataset.resolveUrl || '',
        submitEndpoint: root.dataset.submitUrl || '',
        deepLinkBase: root.dataset.deepLinkBase || 'prugein://guest-terminal',
        installUrl: root.dataset.installUrl || ''
      };

      let currentState = STATE.CHECKING;
      let submitInFlight = false;
      let deepLinkUrl = '';

      const inviteToken = bootstrapInviteToken();

      function clearInlineError() {
        inlineErrorEl.hidden = true;
        inlineErrorEl.textContent = '';
      }

      function setInlineError(message) {
        inlineErrorEl.textContent = message;
        inlineErrorEl.hidden = false;
      }

      function setButtonLock(locked) {
        submitButtonEl.disabled = locked;
        submitButtonEl.setAttribute('aria-busy', locked ? 'true' : 'false');
      }

      function updatePhonePlaceholder() {
        const placeholder = PLACEHOLDERS_BY_CODE[countryCodeEl.value] || 'Phone number';
        phoneInputEl.placeholder = placeholder;
      }

      function setState(nextState) {
        if (TERMINAL_INVITE_STATES[nextState]) {
          writeStoredInvite('');
        }
        currentState = nextState;
        const copy = COPY[nextState] || COPY.invalid;
        headingEl.textContent = copy.heading;
        bodyEl.textContent = copy.body || '\u00A0';

        const showForm = nextState === STATE.VALID;
        const showActions = nextState === STATE.SUCCESS || nextState === STATE.PENDING_REVIEW || nextState === STATE.APP_REQUIRED;
        const showOpenButton = nextState === STATE.SUCCESS || nextState === STATE.APP_REQUIRED || (nextState === STATE.PENDING_REVIEW && Boolean(deepLinkUrl));
        const showInstallArea = nextState === STATE.APP_REQUIRED;

        formEl.hidden = !showForm;
        actionsEl.hidden = !showActions;
        openAppButtonEl.hidden = !showOpenButton;
        installAreaEl.hidden = !showInstallArea;

        fallbackCopyEl.hidden = true;
        if (!showForm) clearInlineError();

        setButtonLock(nextState === STATE.PROCESSING);
      }

      function normalizePhone(rawValue, selectedCountryCode) {
        const trimmed = (rawValue || '').trim();
        if (!trimmed) return null;

        let normalized = '';
        if (trimmed.startsWith('+')) {
          normalized = '+' + trimmed.replace(/\D/g, '');
        } else if (trimmed.startsWith('00')) {
          normalized = '+' + trimmed.slice(2).replace(/\D/g, '');
        } else {
          const countryDigits = (selectedCountryCode || '').replace(/\D/g, '');
          const localDigits = trimmed.replace(/\D/g, '').replace(/^0+/, '');
          normalized = '+' + countryDigits + localDigits;
        }

        if (!/^\+[1-9]\d{7,14}$/.test(normalized)) return null;
        return normalized;
      }

      function mapResolveStatus(statusValue) {
        switch (statusValue) {
          case 'valid':
            return STATE.VALID;
          case 'already_claimed':
            return STATE.CLAIMED;
          case 'expired':
            return STATE.EXPIRED;
          case 'revoked':
          case 'closed':
            return STATE.CLOSED;
          case 'rate_limited':
            return STATE.RATE_LIMITED;
          case 'not_found':
          default:
            return STATE.INVALID;
        }
      }

      function mapSubmitResult(resultValue) {
        switch (resultValue) {
          case 'guest_created':
          case 'guest_resumed':
            return STATE.SUCCESS;
          case 'pending_review':
            return STATE.PENDING_REVIEW;
          case 'app_required':
            return STATE.APP_REQUIRED;
          case 'invite_unavailable':
            return STATE.CLOSED;
          case 'too_many_attempts':
            return STATE.RATE_LIMITED;
          default:
            return STATE.INVALID;
        }
      }

      function buildDefaultDeepLink() {
        const separator = CONFIG.deepLinkBase.includes('?') ? '&' : '?';
        return CONFIG.deepLinkBase + separator + 'invite=' + encodeURIComponent(inviteToken);
      }

      function attemptDeepLinkLaunch() {
        if (!deepLinkUrl) return;
        fallbackCopyEl.hidden = true;
        window.location.href = deepLinkUrl;
        window.setTimeout(function () {
          if (
            currentState === STATE.SUCCESS ||
            currentState === STATE.PENDING_REVIEW ||
            currentState === STATE.APP_REQUIRED
          ) {
            fallbackCopyEl.hidden = false;
          }
        }, 1200);
      }

      async function resolveInvite() {
        setState(STATE.CHECKING);

        if (!inviteToken || !CONFIG.resolveEndpoint) {
          setState(STATE.INVALID);
          return;
        }

        try {
          const response = await fetch(CONFIG.resolveEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ invite: inviteToken })
          });

          if (response.status === 429) {
            setState(STATE.RATE_LIMITED);
            return;
          }

          if (response.status === 403) {
            setState(STATE.INVALID);
            return;
          }

          if (!response.ok) {
            setState(STATE.INVALID);
            return;
          }

          const payload = await response.json();
          setState(mapResolveStatus(payload && payload.status));
        } catch (error) {
          setState(STATE.INVALID);
        }
      }

      async function submitLanding(phoneE164) {
        if (!CONFIG.submitEndpoint) {
          setState(STATE.INVALID);
          return;
        }

        try {
          const response = await fetch(CONFIG.submitEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              invite: inviteToken,
              phone_number: phoneE164
            })
          });

          if (response.status === 429) {
            setState(STATE.RATE_LIMITED);
            return;
          }

          if (response.status === 403) {
            setState(STATE.INVALID);
            return;
          }

          if (!response.ok) {
            setState(STATE.INVALID);
            return;
          }

          const payload = await response.json();
          const mappedState = mapSubmitResult(payload && payload.result);
          deepLinkUrl = '';

          if (mappedState === STATE.SUCCESS || mappedState === STATE.APP_REQUIRED) {
            deepLinkUrl = (payload && payload.deep_link) || buildDefaultDeepLink();
          } else if (mappedState === STATE.PENDING_REVIEW && payload && payload.deep_link) {
            deepLinkUrl = payload.deep_link;
          }

          setState(mappedState);

          if (mappedState === STATE.SUCCESS) {
            attemptDeepLinkLaunch();
          }
        } catch (error) {
          setState(STATE.INVALID);
        }
      }

      formEl.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (submitInFlight) return;

        clearInlineError();
        const phoneE164 = normalizePhone(phoneInputEl.value, countryCodeEl.value);
        if (!phoneE164) {
          setInlineError('Enter a valid phone number in international format.');
          return;
        }

        submitInFlight = true;
        setState(STATE.PROCESSING);
        await submitLanding(phoneE164);
        submitInFlight = false;
        if (currentState !== STATE.PROCESSING) setButtonLock(false);
      });

      openAppButtonEl.addEventListener('click', function () {
        attemptDeepLinkLaunch();
      });

      if (CONFIG.installUrl) {
        installLinkEl.href = CONFIG.installUrl;
        installLinkEl.hidden = false;
      }

      countryCodeEl.addEventListener('change', updatePhonePlaceholder);
      updatePhonePlaceholder();
      resolveInvite();
    }

    function initAll() {
      const roots = document.querySelectorAll('[data-prugein-guest-access-root="true"]');
      roots.forEach(initSection);
    }

    function initFromContainer(container) {
      if (!container) return;
      if (container.matches && container.matches('[data-prugein-guest-access-root="true"]')) {
        initSection(container);
        return;
      }
      const scopedRoot = container.querySelector && container.querySelector('[data-prugein-guest-access-root="true"]');
      if (scopedRoot) initSection(scopedRoot);
    }

    if (!window.__prugeinGuestAccessBootstrapped) {
      window.__prugeinGuestAccessBootstrapped = true;
      document.addEventListener('DOMContentLoaded', initAll);
      document.addEventListener('shopify:section:load', function (event) {
        initFromContainer(event.target);
      });
      document.addEventListener('shopify:section:reorder', function (event) {
        initFromContainer(event.target);
      });
    }

    initAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
